import Lenis from 'lenis';

export default function initSmoothScroll() {
  new Lenis({
    autoRaf: true,
    duration: 1.5,
  });
}